import { waitForMs } from '../../../helpers';

export const drawerOnToggle = () => {
  $(document).on(
    'click',
    '#homepage-v3-drawer-toggler, #drawerv2-close',
    async function () {
      const body = $('body');

      if (body.attr('drawer-opened') === undefined) {
        $('.drawerv2').addClass('show');
        await waitForMs(50);
        body.attr('drawer-opened', '');
      } else {
        body.removeAttr('drawer-opened');
        await waitForMs(350);
        $('.drawerv2').removeClass('show');
      }
    }
  );
};

export const loadDrawer = () => {
  $.ajax({
    url: '/ui/Template@Drawer',
    type: 'post',
    data: { lang: $('html').attr('lang'), uri: location.pathname },
    async: true,
    success: function (data) {
      $('#drawer-wrapper').append(data);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.log(JSON.stringify(jqXHR));
    },
  });
};
